import { render, staticRenderFns } from "./HeaderBox.vue?vue&type=template&id=24a77960&"
import script from "./HeaderBox.vue?vue&type=script&lang=ts&"
export * from "./HeaderBox.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderBox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports